import React from 'react';
import './UpdateEmployee.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';

const UpdateEmployee = () => {
return( 
<div>
  <SideMenuBar></SideMenuBar>
        
    <div class="content">
      <NewHeader></NewHeader>
        
          <div className='row2'>
            <h3 className='directory_Directory'>Directory</h3>  
          </div>
    
          <div className='row4_UpdateEmployee'>
              <p>Employee Database</p>
          </div>

          <div class="row5_UpdateEmployee">
            <div class="row5_column1_UpdateEmployee">
              <p>Name</p>
              <input className='name_input_UpdateEmployee' placeholder='Enter Name'></input>

              <p>Email ID</p>
              <input className='emailID_input_UpdateEmployee' placeholder='Enter Email ID'></input>

              <p>Password</p>
              <input className='password_input_UpdateEmployee' placeholder='Enter Password'></input>

            </div>
  
            <div class="row5_column2_UpdateEmployee">
              <p>Role</p>
              <input className='role_input_UpdateEmployee' placeholder='Enter Role'></input>

              <p>Phone No.</p>
              <input className='phoneNo_input_UpdateEmployee' placeholder='Enter Phone No.'></input>

              <p>Address</p>
              <textarea className='address_input_UpdateEmployee' placeholder='Enter Address'></textarea><br/>
              <button className='update_btn_input_UpdateEmployee'>Update</button>
            </div>
          </div>  
          
    </div>
</div>
 )
}

export default UpdateEmployee;